import {Button, Drawer as ChakraDrawer, DrawerRootProps} from '@chakra-ui/react'
import {LuX} from 'react-icons/lu'

export function Drawer({children, ...props}: DrawerRootProps) {
  return (
    <ChakraDrawer.Root {...props}>
      <ChakraDrawer.Backdrop />
      <ChakraDrawer.Positioner>
        <ChakraDrawer.Content position="relative" display="flex" flexDirection="column" width="100%" maxWidth="xl">
          <ChakraDrawer.CloseTrigger asChild position="absolute" right="4" top="4">
            <Button size="xs" variant="ghost">
              <LuX />
            </Button>
          </ChakraDrawer.CloseTrigger>

          {children}
        </ChakraDrawer.Content>
      </ChakraDrawer.Positioner>
    </ChakraDrawer.Root>
  )
}
